import React from "react";
import StepItem from "../../../components/StepItem";
import { Box, useTheme } from "@mui/material";
import ArrowStepsRegister from "../../../../../../media/images/icons/arrow-steps-register";
import CompanySignup from "../../../components/CompanySignup";
import { useAppSelector } from "../../../../../../hooks/useRedux";

interface Props {
  changeStep?: (step: number) => void;
}

export default function FormSteps({}: Props) {
  const { CampanyRegisterStep } = useAppSelector((state) => state.setting);
  const theme = useTheme();

  const checkStep1 =
    CampanyRegisterStep === "CompanyInfo"
      ? "active"
      : CampanyRegisterStep === "ApproveInfo" ||
        CampanyRegisterStep === "ManagerInfo"
      ? "done"
      : "inActive";

  const checkStep2 =
    CampanyRegisterStep === "ManagerInfo"
      ? "active"
      : CampanyRegisterStep === "ApproveInfo"
      ? "done"
      : "inActive";

  // const checkStep3 = CampanyRegisterStep =

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "16px",
        }}
      >
        <StepItem
          data={{
            step: "CompanyInfo",
            status: checkStep1,
            index: 1,
            title: "اطلاعات شرکت",
          }}
        />
        <ArrowStepsRegister
          color={
            checkStep1 === "done"
              ? theme.palette.success.main
              : theme.palette.info.main
          }
        />
        <StepItem
          data={{
            step: "ManagerInfo",

            status: checkStep2,
            index: 2,
            title: "اطلاعات مدیرعامل",
          }}
        />
        <ArrowStepsRegister
          color={
            checkStep2 === "done"
              ? theme.palette.success.main
              : theme.palette.info.main
          }
        />
        <StepItem
          data={{
            step: "ApproveInfo",

            status:
              CampanyRegisterStep === "ApproveInfo" ? "active" : "inActive",
            index: 3,
            title: "تایید اطلاعات و قوانین",
          }}
        />
      </Box>
    </Box>
  );
}
